import { createContext, useContext } from 'react';
import type { UserRole } from '@tailoring-crm/shared';

/**
 * Who is signed in and which shop they are working in.
 *
 * The shell only READS this — it renders the shop name in the header and the role in the
 * account menu. Signing in, choosing between two shops, and refreshing the session are task
 * 16's job; this context is the seam it plugs into, so no layout code has to change then.
 */
export interface ShopSession {
  shopName: string;
  userName: string;
  role: UserRole;
}

export const SessionContext = createContext<ShopSession | null>(null);

/** Null until a session exists. Callers must handle that rather than assuming a user. */
export function useSession(): ShopSession | null {
  return useContext(SessionContext);
}
